import React from "react";
import styled from "styled-components";

// data
import { primaryMenu } from "data/links";

// components
import SrOnly from "core/SrOnly";
import Link from "core/SiteHeader/components/Link";
import Tools from "./Tools";
import TheNounProject from "./TheNounProject";

// data
import { PRODUCTS_MENU_WIDTH } from "core/SiteHeader/TabletDesktop/Layout/constants.js";

// styles
import { convertPxToRem } from "frontend/components/helpers";
const ProductsMenuStyled = styled.nav`
    flex: 0 0 ${convertPxToRem(PRODUCTS_MENU_WIDTH)};
    display: flex;
    align-items: center;
`;

const LinksStyled = styled.ul`
    margin: 0rem;
    padding: 0rem;

    > li {
        display: inline-block;
    }
`;

const HomLink = styled(Link)`
    margin-left: 0rem;
`;

// component
export const ProductsMenu = ({ className }) => {
    const {
        name,
        links: { home, icons, photos, nounStudio, api },
    } = primaryMenu.products;

    return (
        <ProductsMenuStyled className={className} aria-labelledby="product-menu-links">
            <SrOnly>
                <div id="product-menu-links">{name}</div>
            </SrOnly>
            <LinksStyled>
                <HomLink link={home} />
                <Link link={icons} />
                <Link link={photos} />
                <Link link={nounStudio} />
                <li>
                    <Tools />
                </li>
                <Link link={api} />
                <li>
                    <TheNounProject />
                </li>
            </LinksStyled>
        </ProductsMenuStyled>
    );
};

export default ProductsMenu;

import PropTypes from "prop-types";

// prop-types
ProductsMenu.propTypes = {
    className: PropTypes.string,
};
